/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from 'react';
import { useTheme } from '@providers/theme';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { Header, UsersListComp } from '../components';

import { vappContainer } from '@/application';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
import {
  useSMHolders,
  useSMRevokeCredential,
} from '@pages/HolderPage/machines';
import { HoldersPageService } from '@pages/HolderPage/services';
import { Paginate } from '@vlinder-web/paginate-widget-react';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import toast from 'react-hot-toast';
import { SearchFilter } from '../../../widgets/filter-widget-react';

const getSrv = () => {
  return vappContainer.get<HoldersPageService>(HoldersPageService.displayName);
};

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [refreshPagination, setRefreshPagination] = useState(new Date());
  const srv = getSrv();

  useEffect(() => {
    //srv?.resetCriteria();
  }, []);

  const { holdersPageMachine, holdersPageSend, holdersPageState } =
    useSMHolders({});
  const {
    revokeCredentialMachine,
    revokeCredentialSend,
    revokeCredentialState,
  } = useSMRevokeCredential({});

  console.log('render page', holdersPageState?.event?.data?.value);

  const onRevokeClick = (ids: any) => {
    revokeCredentialSend('START', {
      payload: ids,
    });
  };

  const onRefresh = () => {
    holdersPageSend('TRIGGER_REFRESH', {});
    setRefreshPagination(new Date());
  };

  const onClearFilter = () => {
    // srv?.resetCriteria();
    Array.from(document.querySelectorAll('input')).forEach(
      (input) => (input.value = '')
    );
    holdersPageSend('TRIGGER_REFRESH', {});
  };

  const _renderNotification = () => {
    if (revokeCredentialState?.matches('REVOKE_CREDENTIAL_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getStaticHoldersPageSync()?.notifications
            ?.revokeCredential || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };

  const onPaginationChange = (event: any) => {
    holdersPageSend('TRIGGER_REFRESH', {
      offset: event?.selected * 10,
      size: 10,
    });
  };

  const _renderPagination = () => {
    if (!holdersPageState?.event?.data?.value?.isEmpty) {
      return (
        <Paginate
          {...(holdersPageState?.event?.data?.value || {})}
          onPageChange={onPaginationChange}
          key={refreshPagination}
          totalItems={holdersPageState?.event?.data?.value?.ultUsers?.length}
        />
      );
    }
  };

  const onApplyFilter = (data: any) => {
    let criteria: any = [];
    criteria =
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((item: any) => {
        return {
          column: item?.filters?.inputData?.id,
          op: item?.filters?.inputData?.label,
          value: [item?.filters[item?.filters?.inputData?.label]],
        };
      });
    holdersPageSend('TRIGGER_REFRESH', {
      where: criteria,
    });
  };

  const _renderHoldersList = () => {
    if (holdersPageState?.matches('GET_HOLDERS_LIST')) {
      return (
        <StateOSD
          {...(srv?.agent?.getLoadingHoldersSync()?.loading
            ?.retrieveCredentials || {})}
        />
      );
    }

    if (revokeCredentialState?.matches('REVOKE_CREDENTIAL')) {
      return (
        <StateOSD
          {...(srv?.agent?.getLoadingHoldersSync()?.loading?.revokeCredential ||
            {})}
        />
      );
    }

    if (holdersPageState?.matches('RENDER_HOLDERS_LIST')) {
      return (
        <>
          {holdersPageState?.event?.data?.value?.isEmpty ? (
            <StateOSD
              {...(srv?.agent?.getLoadingHoldersSync()?.loading
                ?.credentialListEmpty || {})}
            />
          ) : (
            <UsersListComp
              {...(holdersPageState?.event?.data?.value || {})}
              onViewDetailClick={props?.onViewDetailClick}
              onRevokeClick={onRevokeClick}
              onRowClick={props?.onViewDetailClick}
            />
          )}
        </>
      );
    }
    return null;
  };

  const _renderErrorModals = () => {
    if (holdersPageState?.matches('RENDER_HOLDERS_LIST_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getErrorHoldersSync()?.error?.formSubmit || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };

  const _renderHeader = () => {
    if (srv?.agent?.getHeaderHoldersSync()?.header) {
      return (
        <>
          <Header
            {...(srv?.agent?.getHeaderHoldersSync()?.header || {})}
            onRefreshClick={onRefresh}
          />
          <SearchFilter
            {...(srv?.agent?.getSettingsHoldersSync()?.settings || {})}
            onFilterApply={onApplyFilter}
            onClearFilter={onClearFilter}
          />
        </>
      );
    }
    return null;
  };

  const _renderPage = () => {
    return (
      <>
        {_renderHeader()}
        {_renderHoldersList()}
        {_renderPagination()}
        {_renderErrorModals()}
        {_renderNotification()}
      </>
    );
  };
  return <>{_renderPage()}</>;
};
